import { createFeatureSelector, createSelector } from '@ngrx/store';

import { APP_VERSION } from 'src/services/utility.service';

import { Tab } from 'src/models/Tab';

import { VersionInfoDTO } from 'src/dtos/updates/VersionInfoDTO';

export interface IAppState {
  readonly appVersion: string;
  apiVersion?: string;
  isAppInitialized: boolean;
  isPagesComponentExisting: boolean;
  tabs: Tab[];
  hasUnseenVersion: boolean;
  unseenPOSVersion?: VersionInfoDTO;
}

export const initialAppState: IAppState = {
  appVersion: APP_VERSION,
  apiVersion: localStorage.getItem('apiVersion') ?? undefined,
  isAppInitialized: false,
  isPagesComponentExisting: false,
  tabs: [],
  hasUnseenVersion: false,
  unseenPOSVersion: undefined,
};

export const selectAppState = createFeatureSelector<IAppState>('app');

export const selectAppVersion = createSelector(
  selectAppState,
  (state) => state.appVersion
);

export const selectApiVersion = createSelector(
  selectAppState,
  (state) => state.apiVersion
);

export const selectIsAppInitialized = createSelector(
  selectAppState,
  (state) => state.isAppInitialized
);

export const selectIsPagesComponentExisting = createSelector(
  selectAppState,
  (state) => state.isPagesComponentExisting
);

export const selectTabs = createSelector(selectAppState, (state) => state.tabs);

export const selectHasUnseenVersion = createSelector(
  selectAppState,
  (state) => state.hasUnseenVersion
);

export const selectUnseenPOSVersion = createSelector(
  selectAppState,
  (state) => state.unseenPOSVersion
);
